module.exports = __webpack_public_path__ + "img/scim.91c1a44d.svg";